import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { Text } from '../text/text';
import styles from './text-label.module.scss';
export const TextLabel = ({ bold, children, className, disabled })=>/*#__PURE__*/ _jsx(Text, {
        bold: bold,
        className: classNames(styles.text, disabled && styles.disabled, className),
        size: "l",
        children: children
    });

//# sourceMappingURL=index.js.map